import { render, staticRenderFns } from "./StaffContents.vue?vue&type=template&id=241598da&scoped=true&"
import script from "./StaffContents.vue?vue&type=script&lang=js&"
export * from "./StaffContents.vue?vue&type=script&lang=js&"
import style0 from "./StaffContents.vue?vue&type=style&index=0&id=241598da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241598da",
  null
  
)

export default component.exports